import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { FormatData } from "utils/FormatData";
import { getFiltersForTable } from "utils/libHelpers/getFiltersForTable";
import { fileDownloadStore } from "./FileDownloadStore";
import { observer } from "mobx-react";
import { ColumnProps } from "antd/lib/table";
import { stringSort, defaultSort } from "utils/defaultSort";
import { Tooltip, Row, Button } from "antd";
import { FileSizeSummarize } from "./FileSizeSummarize";
import { toJS } from "mobx";
import { Table } from "Components/General/Table";

interface DownloadFilesTableProps extends WithTranslation {
  onNext: () => void;
  onDone: () => void;
}

interface API_DownloadWizardRequestFileWithSlaves extends API_DownloadWizardRequestFile {
  slaves?: API_DownloadWizardRequestFile[];
}

export const DownloadFilesTable = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<DownloadFilesTableProps, {}> {
      constructor(props: DownloadFilesTableProps) {
        super(props);
      }

      get columns(): ColumnProps<API_DownloadWizardRequestFile>[] {
        const { t } = this.props;
        return [
          {
            dataIndex: "path",
            title: t("File path"),
            width: 200,
            sorter: false,
            render: (text?: string, record?: API_DownloadWizardRequestFile) => {
              const pathShort = record.path ? (
                <span>{`.../${text.split("/").filter(Boolean).pop()}`}</span>
              ) : (
                <span>/</span>
              );
              const pathFull = record.path ? `.../${text}` : "/";
              return <Tooltip title={pathFull}>{pathShort}</Tooltip>;
            },
            ellipsis: true,
          },
          {
            dataIndex: "name",
            title: t("Filename"),
            width: 300,
            sorter: (a, b) => stringSort(a, b, "name"),
            ellipsis: true,
          },
          {
            dataIndex: "index",
            title: t("Index"),
            width: 100,
            sorter: (a, b) => defaultSort(a, b, "size"),
            render: (text?: string, record?: API_DownloadWizardRequestFile) => (record.index ? text : ""),
            ellipsis: true,
          },
          {
            dataIndex: "fileType",
            title: t("Type"),
            width: 120,
            render: (text?: string, record?: API_DownloadWizardRequestFile) => (record.fileType ? text : ""),
            filters: getFiltersForTable(fileDownloadStore.files, "fileType"),
            onFilter: (value: string, record: API_DownloadWizardRequestFile) => record.fileType.indexOf(value) === 0,
          },
          {
            dataIndex: "size",
            title: t("Size"),
            width: 100,
            sorter: (a, b) => defaultSort(a, b, "size"),
            render: (text?: number) => (text ? FormatData.formatBytes(text, 1) : "-"),
          },
          // {
          //   dataIndex: 'id',
          //   width: 52,
          //   style: { textAlign: 'center' },
          //   render: ({ rowData }: { rowData: API_DownloadWizardRequestFile }) => (
          //     <span onClick={() => fileDownloadStore.removeFile(rowData.id)} style={{ cursor: 'pointer' }}>
          //       <FontAwesomeIcon icon={['far', 'trash-alt']} fixedWidth={true} />
          //     </span>
          //   ),
          //   sorter: true,
          // }
        ];
      }

      render() {
        const rowSelection = {
          selectedRowKeys: fileDownloadStore.postFiles,
          onChange: (selectedRowKeys) => {
            fileDownloadStore.setFiles(selectedRowKeys);
          },
        };
        const { t, onDone, onNext } = this.props;
        return (
          <>
            <div className="scrollable-table-wrapper download-files-table mb-2">
              <Table<API_DownloadWizardRequestFileWithSlaves>
                name="downloadFilesTable"
                loading={fileDownloadStore.state === "LOADING"}
                rowKey={(record) => `${record.id}`}
                dataSource={toJS(fileDownloadStore?.files)}
                columns={this.columns}
                pagination={{ hideOnSinglePage: true }}
                expandable={{
                  childrenColumnName: "slaves",
                }}
                rowSelection={rowSelection}
              />
            </div>
            <Row justify="space-between">
              <FileSizeSummarize files={fileDownloadStore.selectedFiles} />
              <div>
                <Button className="mr-5" disabled={!fileDownloadStore.postFiles.length} onClick={onDone}>
                  {t("Download instantly")}
                </Button>
                <Button type="primary" onClick={onNext} disabled={fileDownloadStore.furtherOptionsDisabled}>
                  {t("Add further options")}
                </Button>
              </div>
            </Row>
          </>
        );
      }
    }
  )
);
